export var SchemaErrorCode;
(function (SchemaErrorCode) {
    SchemaErrorCode[SchemaErrorCode["NotSupport"] = 16000] = "NotSupport";
    SchemaErrorCode[SchemaErrorCode["Native"] = 16001] = "Native";
    SchemaErrorCode[SchemaErrorCode["Validate"] = 17000] = "Validate";
    SchemaErrorCode[SchemaErrorCode["UnKnow"] = 18000] = "UnKnow";
})(SchemaErrorCode || (SchemaErrorCode = {}));
export var SchemaType;
(function (SchemaType) {
    SchemaType["Method"] = "method";
    SchemaType["Event"] = "event";
})(SchemaType || (SchemaType = {}));
